/**
 * Lista fibras para selectores (NAP, etc.) cuando el cable existe pero la API/BD
 * aún no devuelve buffers/fibras poblados (null o []).
 */

const COLORES_TIA598 = [
  'azul',
  'naranja',
  'verde',
  'marron',
  'gris',
  'blanco',
  'rojo',
  'negro',
  'amarillo',
  'violeta',
  'rosa',
  'turquesa',
] as const

export type FibraPickerItem = {
  fibraId: string
  bufferNum?: number
  bufferColor?: string
  fibraNum: number
  fibraColor: string
  estado: string
}

export function listFibrasParaPicker(cable: {
  id: string
  numeroFibras: number
  tieneBuffers: boolean
  buffers?: Array<{
    numero: number
    color: string
    fibras: Array<{ numero: number; color: string; estado: string; fibraId: string }>
  }>
  fibras?: Array<{ numero: number; color: string; estado: string; fibraId: string }>
}): FibraPickerItem[] {
  const out: FibraPickerItem[] = []

  if (cable.tieneBuffers && cable.buffers && cable.buffers.length > 0) {
    for (const buffer of cable.buffers) {
      for (const fibra of buffer.fibras) {
        out.push({
          fibraId: fibra.fibraId,
          bufferNum: buffer.numero,
          bufferColor: buffer.color,
          fibraNum: fibra.numero,
          fibraColor: fibra.color,
          estado: String(fibra.estado ?? 'libre'),
        })
      }
    }
    if (out.length > 0) return out
  }

  if (cable.fibras && cable.fibras.length > 0) {
    for (const fibra of cable.fibras) {
      out.push({
        fibraId: fibra.fibraId,
        fibraNum: fibra.numero,
        fibraColor: fibra.color,
        estado: String(fibra.estado ?? 'libre'),
      })
    }
    return out
  }

  const n = Math.min(288, Math.max(1, Math.round(Number(cable.numeroFibras)) || 1))
  for (let i = 0; i < n; i++) {
    const color = COLORES_TIA598[i % 12]
    out.push({
      fibraId: `${cable.id}|SYN|${i + 1}`,
      fibraNum: i + 1,
      fibraColor: color,
      estado: 'libre',
    })
  }
  return out
}
